import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IDailyStatistic, IKeywordRealTimeStatistic, IKeywordPublishedStatistic, IMediaStatistic, ISurvivalStatistic, IHourlyStatistic, IApprovedArticleStatistic, ICategoryStatistic } from "./types/_statistic";
const api = new APIClient();

const path = '/';
const statisticApi = {
  survivalStatistics(params: any): Promise<AxiosResponse<ResponseData<ISurvivalStatistic[]> & PaginationResponse, any>> {
    const url = `/news/survival-statistics`
    return api.get(url, params)
  },
  dailyStatistics(params: any): Promise<AxiosResponse<ResponseData<IDailyStatistic[]> & PaginationResponse, any>> {
    const url = `/news-trackings/statistics`
    return api.get(url, params)
  },
  hourlyStatistics(params: any): Promise<AxiosResponse<ResponseData<IHourlyStatistic[]> & PaginationResponse, any>> {
    const url = `/news-trackings/statistics-hourly`
    return api.get(url, params)
  },
  keywordRealTimeStatistics(params: any): Promise<AxiosResponse<ResponseData<IKeywordRealTimeStatistic[]> & PaginationResponse, any>> {
    const url = `/keyword-statistics`
    return api.get(url, params)
  },
  keywordPublishedStatistics(params: any): Promise<AxiosResponse<ResponseData<IKeywordPublishedStatistic[]> & PaginationResponse, any>> {
    const url = `/keyword-statistics/published`
    return api.get(url, params)
  },
  mediaStatistics(params: any): Promise<AxiosResponse<ResponseData<IMediaStatistic[]> & PaginationResponse, any>> {
    const url = `/partner-statistics`
    return api.get(url, params)
  },
  downloadExcelMediaStatistics(params: any): Promise<AxiosResponse<ResponseData<IMediaStatistic[]> & PaginationResponse, any>> {
    const url = `/partner-statistics/export`
    return api.get(url, params)
  },
  categoryStatistics(params: any): Promise<AxiosResponse<ResponseData<ICategoryStatistic[]> & PaginationResponse, any>> {
    const url = `/categories/statistics`
    return api.get(url, params)
  },
  downloadExcelCategoryStatistics(params: any): Promise<AxiosResponse<ResponseData<ICategoryStatistic[]> & PaginationResponse, any>> {
    const url = `/categories/statistics/export`
    return api.get(url, params)
  },
  approvedArticleStatistics(params: any): Promise<AxiosResponse<ResponseData<IApprovedArticleStatistic[]> & PaginationResponse, any>> {
    const url = `/news-trackings/statistics-approved`
    return api.get(url, params)
  },

}
export default statisticApi
